import { accessRole } from "../../../../../helpers/access_role"
import { config } from "../../../../../helpers/config_global"
import React, { useState, Component, Fragment } from "react"
import { Redirect } from "react-router-dom"

import { Tooltip } from "reactstrap"

import MKIDatatable from '../../../../../modules/mki-datatable/lib'
import { ConfirmAlert } from '../../../../../helpers/ui/alert'

import { cancelToken } from "../../../../../services/adapters/kepegawaian/hukdisService"

import DataTableBloc from '../Blocs/DataTableBloc'
import apiResponse from '../../../../../services/apiResponse'
import moment from "moment"

const reformatDate = (date) => {
    const months = [
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember",
    ];
    const d = new Date(date);
    let dt = d.getDate()
    if (dt < 10)
        dt = '0'+dt

    return dt + " " + months[d.getMonth()] + " " + d.getFullYear();
};



class TableManualComponent extends Component {
    dataTableBloc = new DataTableBloc();

    source
    historyTable = 'ManualHukdislists'
    defaultOrder = 'punishment_discipline_id'
    defaultSize = 10
    defaultSort = 'desc'
    configDatatable = {
        ...config('datatable'),
        sort: {
            column: this.defaultOrder,
            order: this.defaultSort
        }
    }
    
    constructor(props) {
        super(props)
        this.state = {
            tooltip: false,
            detailUuid: null,
            updateUuid: null,
            approveUuid: null,
            inactiveUuid: null,
            defaultSize: 10,
            rows: [],
            totalRow: 0,
            loadingTable: true,
            filter: sessionStorage.getItem(this.historyTable) ?
            JSON.parse(sessionStorage.getItem(this.historyTable)) :
            {
                filter_value: "",
                page_number: 1,
                page_size: this.defaultSize,
                sort_order: {
                    column: this.defaultOrder,
                    order: this.defaultSort
                }
            }
        }
    }
    toggleTooltip = () => this.setState({ tooltip: !this.state.tooltip });
    updatestatus = (period_promotion_uuid) => {
        console.log(period_promotion_uuid);
        this.dataTableBloc.createChannel.subscribe((result) => {
          switch (result.status) {
            case apiResponse.COMPLETED:
              if (result.data.status) {
                let response = result.data.response;
                this.setState({
                  //rankItems: reformatRank(response.result),
                });
              }
              break;
            case apiResponse.ERROR:
              break;
            default:
              break;
          }
        });
        this.dataTableBloc.fetchCreate({
            period_promotion_uuid: period_promotion_uuid
          });
      };
    loadData = async () => {
        /* history Datatable */
        sessionStorage.setItem(this.historyTable, JSON.stringify(this.state.filter))

        /* kirim ke server */
        let offset = (this.state.filter.page_number-1)*this.state.filter.page_size
        if(this.state.defaultSize!==this.state.filter.page_size) {
            this.setState({
                defaultSize: this.state.filter.page_size
            })
            offset = 0
            this.configDatatable.page_number = 1
        }
        const query = {
            search: this.state.filter.filter_value,
            limit: this.state.filter.page_size,
            offset: offset,
            order: this.state.filter.sort_order.column,
            sort: this.state.filter.sort_order.order,
            status: 1
        }
        await this.dataTableBloc.fetchManualRowTable(query, this.source.token)
    }

    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel();
        }
        this.source = cancelToken()
        this.loadData()
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.inactiveData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }
    
    inactiveData = async () => {
        await this.dataTableBloc.fetchInactive({ uuid: this.state.inactiveUuid })
    }

    dateParse = (input) => {
        let res = "-";
        if (input != "" && input != null){
          res = moment(input).format('DD/MM/YYYY')
        }

        return res;
    }

    componentDidMount() {
        this.setTokenAPI()
        // alert(this.props.currentRoleId);
        this.dataTableBloc.rowtableManulChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.INITIAL:
                    this.setState({
                        loadingTable: false
                    })
                    break
                case apiResponse.LOADING:
                    this.setState({
                        loadingTable: true
                    })
                    break
                case apiResponse.COMPLETED:
                    const response = result.data.response
                    this.setState({
                        totalRow: response.total,
                        rows: response.result,
                        loadingTable: false
                    })
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })

        this.dataTableBloc.inactiveChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                        loadingTable: true
                    }, function () {
                        this.setTokenAPI()
                        //this.props.handleInactiveSuccess()
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })
    }

    componentWillUnmount() {
        this.dataTableBloc.rowtableManulChannel.unsubscribe()
    }

    columns = [
        {
            key: "punishment_discipline_start_date",
            text: "Periode",
            className: "punishment_discipline_start_date",
            sortable: true,
            width: '130',
            cell: record => {
                return this.dateParse(record.punishment_discipline_sk_tmt_date)+' s/d '+ this.dateParse(record.punishment_discipline_end_date)
            }
        },
        {
            key: "punishment_discipline_employee_nip",
            text: "NIP",
            className: "punishment_discipline_employee_nip",
            sortable: true,
            width: '140'
        },
        {
            key: "punishment_discipline_employee_name",
            text: "Nama",
            className: "punishment_discipline_employee_name",
            sortable: true,
            width: '200'
        },
        {
            key: "punishment_discipline_sk_number",
            text: "Nomor SK",
            className: "punishment_discipline_sk_number",
            sortable: true,
            width: '140'
        },
        {
            key: "punishment_discipline_sk_tmt_date",
            text: "TMT SK",
            className: "punishment_discipline_sk_tmt_date",
            sortable: true,
            width: '130',
            cell: record => {
                return this.dateParse(record.punishment_discipline_sk_tmt_date)
            }
        },
        {
            key: "punishment_discipline_result_final_punishment_name",
            text: "Hasil Akhir Hukuman Disiplin",
            className: "punishment_discipline_result_final_punishment_name",
            sortable: true,
            // width: '230'
        },
        {
            key: "punishment_discipline_cut_percent",
            text: "Potongan",
            className: "punishment_discipline_cut_percent",
            sortable: true,
            width: '130',
            cell: record => {
                return record.punishment_discipline_cut_percent+ ' %'
            }
        },
        {
            key: "punishment_discipline_status_name",
            text: "Status",
            className: "punishment_discipline_status_name",
            sortable: true,
            width: '200'
        },
        {
            key: "action",
            text: "Action",
            className: "action",
            width: 120,
            sortable: false,
            align: 'center',
            cell: record => {
                const thisId = record.punishment_discipline_id
                var  status = record.punishment_discipline_status
                return (
                    <Fragment>
                        { accessRole('read') && status == 1 &&
                            <span>
                                <button
                                    className="btn btn-primary btn-sm"
                                    id={"detail-" + thisId}
                                    onClick={() => {
                                        this.setState({
                                            detailUuid: record.punishment_discipline_uuid
                                        })
                                    }}
                                    style={{
                                        marginRight: '2px',
                                        padding: '2px 5px'
                                    }}>
                                        <i className="uil-align-left"></i>
                                </button>
                                <Tooltip
                                    style={{
                                        marginBottom: 2
                                    }}
                                    placement="top" isOpen={this.state["detail" + thisId]} target={"detail-" + thisId}
                                    toggle={() => {
                                        this.setState({
                                            ["detail" + thisId] : !this.state["detail" + thisId]
                                        })
                                    }}
                                >Detail</Tooltip>
                            </span>
                        }

                    </Fragment>
                );
            }
        }        
    ]

    render() {
        return (
            <>
                <MKIDatatable
                    className={this.configDatatable.tableClass}
                    config={this.configDatatable}
                    records={this.state.rows}
                    columns={this.columns}
                    dynamic={true}
                    minWidth={1000}
                    total_record={this.state.totalRow}
                    initial={this.state.filter}
                    onChange={(filter) => {
                        this.setState({
                            loadingTable: true,
                            filter: filter
                        }, function () {
                            this.setTokenAPI()
                        });
                    }}
                    loading={this.state.loadingTable}
                />
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menghapus data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil dihapus"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal dihapus"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.detailUuid !== null ?
                    <Redirect to={"/kepegawaian/hukuman_disiplin.html?detailmanual&uuid=" + this.state.detailUuid}/>
                : null }
                {/* { this.state.updateUuid !== null ?
                    <Redirect to={"/kepegawaian/hukuman_disiplin.html?pegawai&uuid=" + this.state.updateUuid}/>
                : null }
                { this.state.approveUuid !== null &&
                    <Redirect to={"/kepegawaian/hukuman_disiplin.html?approveperiode&uuid=" + this.state.approveUuid}/>
                } */}
            </>
        )
    }

}

export default TableManualComponent